import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/views/Login.vue';
import Logout from '@/views/Logout.vue';
import ResetPassword from '@/views/ResetPassword.vue';

const Dashboard = () => import('@/views/Dashboard/index');
const SplAccess = () => import('@/views/SplAccess.vue');
const VideoMode = () => import('@/views/VideoMode/index');
const Admin = () => import('@/views/Admin/index');

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false, adminAuth: false, staffAuth: false },
  },
  {
    path: '/access',
    name: 'SplAccess',
    component: SplAccess,
    meta: { requiresAuth: false, adminAuth: false, staffAuth: false },
  },
  {
    path: '/reset',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { requiresAuth: true, adminAuth: false, staffAuth: false },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    meta: { requiresAuth: true, adminAuth: false, staffAuth: false },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true, adminAuth: false, staffAuth: false },
  },
  {
    path: '/videomode',
    name: 'VideoMode',
    component: VideoMode,
    meta: { requiresAuth: true, adminAuth: false, staffAuth: false },
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: { requiresAuth: true, adminAuth: false, staffAuth: true },
  },
];

const router = new Router({ routes, mode: 'history' });

// Navigation guard
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    const authDetails = JSON.parse(localStorage.getItem('auth_details'));
    if (!authDetails || !authDetails.token) {
      next({ name: 'Login' });
    } else if (to.meta.staffAuth) { // or !adminAuth??
      if (authDetails.role === 'staff' || authDetails.role === 'admin') {
        next();
      } else {
        next({ name: 'Dashboard' });
      }
    } else if (to.meta.adminAuth) {
      if (authDetails.role === 'admin') {
        next();
      } else if (authDetails.role === 'staff') {
        next({ name: 'Admin' });
      } else {
        next({ name: 'Dashboard' });
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

export { router };
